
// @ts-nocheck


export const localeCodes =  [
  "en",
  "pl"
]

export const localeLoaders = {
  en: [
    {
      key: "locale_translation_46json_9c3d854a",
      load: () => import("#nuxt-i18n/9c3d854a" /* webpackChunkName: "locale_translation_46json_9c3d854a" */),
      cache: true
    }
  ],
  pl: [
    {
      key: "locale_translation_46json_eec7271f",
      load: () => import("#nuxt-i18n/eec7271f" /* webpackChunkName: "locale_translation_46json_eec7271f" */),
      cache: true
    }
  ]
}

export const vueI18nConfigs = [
  () => import("#nuxt-i18n/38629a52" /* webpackChunkName: "config_i18n_46config_46ts_38629a52" */)
]

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: true
  },
  compilation: {
    jit: true,
    strictMessage: true,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "en",
      name: "EN",
      language: "en",
      files: [
        "/vercel/path0/src/locales/langs/dev/en/translation.json"
      ]
    },
    {
      code: "pl",
      name: "PL",
      language: "pl",
      files: [
        "/vercel/path0/src/locales/langs/dev/pl/translation.json"
      ]
    }
  ],
  defaultLocale: "pl",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "prefix",
  lazy: true,
  langDir: "../src/locales/langs/dev",
  rootRedirect: undefined,
  detectBrowserLanguage: false,
  differentDomains: false,
  baseUrl: "",
  customRoutes: "config",
  pages: {
    "index/index": {
      en: "",
      pl: false
    },
    "cars/index": {
      en: "/cars",
      pl: "/samochody"
    },
    "short-term/index": {
      en: "/short-term-rental",
      pl: "/wynajem-krotkoterminowy"
    },
    "medium-term/index": {
      en: "/medium-term-rental",
      pl: "/wynajem-srednioterminowy"
    },
    "long-term/index": {
      en: "/long-term-rental",
      pl: "/wynajem-dlugoterminowy"
    },
    "2months/index": {
      en: "/for-a-2-months-rental",
      pl: "/wynajem-auta-na-2-miesiace"
    },
    "3months/index": {
      en: "/for-a-3-months-rental",
      pl: "/wynajem-auta-na-3-miesiace"
    },
    "6months/index": {
      en: "/for-a-6-months-rental",
      pl: "/wynajem-auta-na-6-miesiecy"
    },
    "weekend-rental/index": {
      pl: "/wynajem-auta-na-weekend"
    },
    "holiday-rental/index": {
      pl: "/wynajem-auta-na-wakacje"
    },
    "holiday-abroad-rental/index": {
      pl: "/wynajem-auta-na-wakacje-za-granica"
    },
    "business-trip-rental/index": {
      pl: "/wynajem-auta-na-podroz-sluzbowa"
    },
    "rent-tesla/index": {
      en: "/rent-tesla",
      pl: "/tesla-wynajem"
    },
    "electric-car-rental/index": {
      en: "/electric-car-rental",
      pl: "/wypozyczalnia-samochodow-elektrycznych"
    },
    "6bus/index": {
      en: "/6-seat-bus-rental",
      pl: "/wynajem-busa-6-osobowego"
    },
    "7bus/index": {
      en: "/7-seat-bus-rental",
      pl: "/wynajem-busa-7-osobowego"
    },
    "8bus/index": {
      en: "/8-seat-bus-rental",
      pl: "/wynajem-busa-8-osobowego"
    },
    "9bus/index": {
      en: "/9-seat-bus-rental",
      pl: "/wynajem-busa-9-osobowego"
    },
    "bus-rental/index": {
      en: "/passenger-bus-rental",
      pl: "/wynajem-busow-osobowych"
    },
    "delivery-bus-rental/index": {
      en: "/passenger-delivery-bus-rental",
      pl: "/wynajem-busow-dostawczych"
    },
    "refrigeration-van-rental/index": {
      en: "/refrigeration-van-rental",
      pl: "/wynajem-samochodu-chlodnia"
    },
    "insurance-replacement/index": {
      en: "/a-replacement-car-from-the-perpetrators-liability-insurance",
      pl: "/wynajem-z-oc-sprawcy"
    },
    "locations/index": {
      en: "/branches",
      pl: "/oddzialy"
    },
    "contact/index": {
      en: "/contact",
      pl: "/kontakt"
    },
    "faq/index": {
      en: "/faq",
      pl: "/faq"
    },
    "privacy-policy/index": {
      en: "/policy",
      pl: "/polityka"
    },
    "terms-of-service/index": {
      en: "/regulations",
      pl: "/regulamin"
    },
    "general-terms-and-conditions/index": {
      en: "/general-terms",
      pl: "/owu"
    },
    "delete-account/index": {
      en: "/delete-account",
      pl: "/usun-konto"
    },
    "documents/index": {
      en: "/documents",
      pl: "/dokumenty"
    },
    "about-us/index": {
      en: "/about-us",
      pl: "/onas"
    },
    "car-rental-[urlSlug]/index": {
      en: "/car-rental-[urlSlug]",
      pl: "/wypozyczalnia-samochodow-[urlSlug]"
    },
    "create-new-password/index": {
      en: "/create-new-password",
      pl: "/nowe-haslo"
    },
    "verify-email/index": {
      en: "/verify-email",
      pl: "/zweryfikuj-email"
    },
    "blog/index": {
      en: "/blog",
      pl: "/blog"
    },
    "blog/[...newsTitle]/index": {
      en: "/blog/[...newsTitle]",
      pl: "/blog/[...newsTitle]"
    },
    "reservation/index": {
      en: "/reservation",
      pl: "/rezerwacja"
    },
    "sign-in/index": {
      en: "/sign-in",
      pl: "/logowanie"
    },
    "account/index": {
      en: "/account",
      pl: "/konto"
    },
    "account/data/index": {
      en: "/account/data",
      pl: "/konto/zmien-dane"
    },
    "account/orders/index": {
      en: "/account/orders",
      pl: "/konto/zamowienia"
    },
    "account/password/index": {
      en: "/account/password",
      pl: "/konto/haslo"
    },
    "account/notifications/index": {
      en: "/account/notifications",
      pl: "/konto/powiadomienia"
    },
    "account/language/index": {
      en: "/account/language",
      pl: "/konto/jezyk"
    },
    "loyalty-program/index": {
      en: "/loyalty-program",
      pl: "/program-lojalnosciowy"
    },
    "reservation/completed/[orderID]/index": {
      en: "/reservation-summary/[orderID]",
      pl: "/podsumowanie-rezerwacji/[orderID]"
    }
  },
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  legacy: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "en",
    name: "EN",
    language: "en",
    files: [
      {
        path: "/vercel/path0/src/locales/langs/dev/en/translation.json",
        cache: undefined
      }
    ]
  },
  {
    code: "pl",
    name: "PL",
    language: "pl",
    files: [
      {
        path: "/vercel/path0/src/locales/langs/dev/pl/translation.json",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/